<template>
	<div class="text-center">
		<div class="mt-5 text-danger" style="font-size:10em;font-weight:bolder;">
			404
		</div>
		<h3 class="text-danger">
			La página que buscas no se encuentra
		</h3>
	</div>
</template>

<script>
export default {
	name: '404'
}
</script>



// WEBPACK FOOTER //
// src/modulos/core/vue/components/main/404.vue